<template>
    <v-container class="pl-0">
        <entity-nav :navItems="navItems" useEvents></entity-nav>
        <div class="entityView">
            <keep-alive exclude="PlotReader">
                <router-view></router-view>
            </keep-alive>
        </div>
    </v-container>
</template>
<script>
import EntityNav from '../../components/EntityNav.vue'
import { mapState } from 'vuex'
import permissionsSet from '../../components/permissions'
const entity = 'plot'
export default {
    name: 'PlotHome',
    components: {
        'entity-nav': EntityNav,
    },
    computed: {
        ...mapState(['user']),
        navItems() {
            let items = [
                { title: 'List', icon: 'mdi-view-list', to: 'plot' },
                { title: 'Archive', icon: 'mdi-delete-outline', to: 'plotArchive' },
            ]
            if (this.canCreate) items = [{ title: 'New', icon: 'mdi-plus', to: 'newPlot' }, ...items]

            return items
        },
        canCreate() {
            if (this.user && this.user[entity]) {
                return this.user[entity].owned.includes(permissionsSet.Create)
            } else {
                return false
            }
        },
    },
}
</script>
<style>
.entityView {
    width: 100%;
}
</style>
